/**
 * HTTP API exports
 * Main entry point for HTTP client functionality
 */

export { HttpClient, ApiError } from './api';
export { defaultApiConfig, ApiErrorCode } from './config';
export type { 
    ApiConfig, 
    HttpMethod, 
    RequestBody, 
    RequestOptions, 
    ApiResponse, 
    IHttpClient, 
    GetAuthTokenFunction,
    RequestInterceptor,
    ResponseInterceptor,
    ErrorInterceptor
} from './types';

// Default HTTP client instance
import { HttpClient } from './api';
export const httpClient = new HttpClient();
